<template>
     <section class="sub_contents_wrap container">
        <div v-for="(classes,index) in classList" :key="index" class="cp_box">
            <div class="cp_group">
                <p class="group_name">{{classes.className}}</p>
            </div>
            <div v-for="(contact,index) in contactList" :key="index" class="group_info">
                <div v-if="classes.orgClass == contact.classId" class="row">
                    <div class="col-md-2">
                        <span class="g_i_text">{{contact.userName}}</span>
                    </div>
                     <div class="col-md-3">
                         <span class="g_i_text">{{contact.contactEmail}}</span>
                    </div>
                    <div class="col-md-4">
                        <span class="g_i_text">{{contact.contactDesc}}</span>
                    </div>
                     <div class="col-md-3">
                        <span class="g_i_text">{{contact.contactPhone}}</span>
                    </div>
                </div>
            </div>
        </div>
	</section>
</template>

<script>
import { getContactList } from '@/api/contact';


export default {
 data() {
    return {
		contacts : [],
		classList : [],
		contactList : [],
		oldCls : '',
		clsCount : 1,
		rowCount : 0,
		subCount : 0,
    };
  },
  created(){
    this.fetchData();
	if(this.contacts.orgClass != this.oldCls){
		this.clsCount = 1,
		this.rowCount = 0,
		this.subCount = this.contacts.rowidx;
	}
  },  
  methods: {
	async fetchData(){  
	try {
		const response = await getContactList();
		this.contacts = response.data.contacts; 
		this.classList = response.data.clsList; 
		this.contactList = response.data.contactMem; 
	} catch (error) {
		console.log(error);
	}
	},	
    showFaq(boardId){
      this.boardId = boardId; 
      this.$refs.removeClass("active");

    }
}
};
</script>

<style>

</style>